import { Component } from '@angular/core';
import { NavParams, PopoverController, ViewController } from 'ionic-angular';
import 'rxjs';
import { AlertService } from '../../../providers/alert-service';
import { ArquivosService } from '../../../providers/arquivos-service';
import { FileService } from '../../../providers/file-service';
import { GestaoPcaService } from "../../../providers/gestao-pca-service";
import { UsuarioService } from "../../../providers/usuario-service";
import { PopoverAssinantesPage } from "../../popovers/popover-assinantes";
import { PopoverOptions } from "ionic-angular/components/popover/popover-options";
import { AGORA } from "../../../app/AGORA";

declare var dtjava: any;

@Component({
  selector: 'page-modal-arquivos-contratos',
  templateUrl: 'modal-arquivos-contratos.html',
  providers: [
    AGORA
  ]
})
export class ModalArquivosContratosPage {

  isModuloPeca: boolean = false;
  PCAAtiva: any;
  tipoDocumento: any;
  titulo: any;
  isJurisdicionado: any;
  isCGE: any;
  IdProcesso: any = null;
  idModuloPCA: any = null;
  tipoAnalise: any = null;
  tipoEntidadeExercicio: any = null;
  listaTipoDocumentos: any[] = null;
  usuarioLogado: any;
  loading: boolean = true;
  tiposAceitos: any = "application/pdf";
  listaArquivosPCA: any;
  origemArquivo: any;
  origemFilter: any;
  listaPecasProcessuaisObrigatoria: any[];
  origemModal: boolean = false;
  disabled: boolean = false;
  buscaArquivo: string = "";
  idProcessoJustificativa: number = null;

  analise: any = null;

  constructor(public AGORA: AGORA,
    private alertService: AlertService,
    public popoverCtrl: PopoverController,
    private fileService: FileService,
    private viewCtrl: ViewController,
    public navParams: NavParams,
    public arquivoService: ArquivosService,
    public gestaoPcaService: GestaoPcaService,
    public usuarioService: UsuarioService) {

    this.usuarioLogado = this.usuarioService.obtemUsuario();
    this.PCAAtiva = this.gestaoPcaService.getPCA();
    console.log("PCAATIVA:");
    console.log(this.PCAAtiva);

    this.titulo = this.navParams.get('titulo');

    if (this.navParams.get('isModuloPeca') != undefined) {
      this.isModuloPeca = this.navParams.get('isModuloPeca');
    }

    if (this.navParams.get('idProcessoJustificativa') != undefined) {
      this.idProcessoJustificativa = this.navParams.get('idProcessoJustificativa');
    }

    this.isJurisdicionado = this.navParams.get('jurisdicionado');
    this.isCGE = this.navParams.get('isCGE');
    this.IdProcesso = this.navParams.get('IdProcesso');
    this.idModuloPCA = this.navParams.get('idModuloPCA');
    this.tipoAnalise = this.navParams.get('tipoAnalise');
    this.listaTipoDocumentos = this.navParams.get('listaTipoDocumentos');
    this.analise = this.navParams.get('analise');
    this.tipoEntidadeExercicio = this.navParams.get('tipoEntidadeExercicio');
    this.tipoDocumento = this.navParams.get('tipodocumento');

    console.log("Tipo Documento: " + this.tipoDocumento);

    this.origemFilter = this.navParams.get('origemFilter');

    if (this.navParams.get('origemArquivo') != undefined && this.navParams.get('origemArquivo') != null) {
      this.origemArquivo = this.navParams.get('origemArquivo');
    } else {
      this.origemArquivo = 'NA';
    }

    if (this.navParams.get('origemFilter') != undefined) {
      this.origemFilter = this.navParams.get('origemFilter');
    } else {
      this.origemFilter = null;
    }

    // if (this.IdProcesso != '' && this.IdProcesso != undefined && this.IdProcesso != 0) {
    //   this.origemModal = true;
    // }

    this.carregarModal();

  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  carregarModal() {
    this.listarArquivosPCA();
  }

  listarArquivosPCA() {

    if (this.listaTipoDocumentos != null && this.listaTipoDocumentos.length > 0) {
      this.arquivoService.listarArquivosVinculadosPorModuloPcaPorTipoDocumento(this.idModuloPCA, this.listaTipoDocumentos,false).subscribe(data => {
        if (this.tipoEntidadeExercicio != undefined && this.tipoEntidadeExercicio != 0) {
          if (this.idProcessoJustificativa == null) {
            this.listaArquivosPCA = data.filter((arquivo) => arquivo.peca.idTipoEntidadeExercicio == this.tipoEntidadeExercicio);
          } else {
            this.listaArquivosPCA = data.filter((arquivo) => arquivo.peca.idTipoEntidadeExercicio == this.tipoEntidadeExercicio && arquivo.idProcesso != this.idProcessoJustificativa);
          }
        } else {
          this.listaArquivosPCA = data;
        }
        this.loading = false;
      }, error => {
        this.loading = false;
        this.alertService.mostraAlerta("", "Ocorreu um erro ao listar os arquivos:" + error);
      });

    } else {
      this.arquivoService.listarPecasVinculadasPCA(this.IdProcesso, this.idModuloPCA, this.tipoAnalise, false).subscribe(data => {
        if (this.tipoEntidadeExercicio != undefined && this.tipoEntidadeExercicio != 0) {
          this.listaArquivosPCA = data.filter((arquivo) => arquivo.peca.idTipoEntidadeExercicio == this.tipoEntidadeExercicio);
        } else {
          this.listaArquivosPCA = data;
        }
        this.loading = false;
      }, error => {
        this.loading = false;
        this.alertService.mostraAlerta("", "Ocorreu um erro ao listar os arquivos:" + error);
      });
    }

    this.arquivoService.listarPecasProcessuaisObrigatoria(this.idModuloPCA).subscribe(data => {
      this.listaPecasProcessuaisObrigatoria = data;

      this.arquivoService.listarPecasProcessuaisNObrigatoria(this.idModuloPCA).subscribe(data2 => {

        if (data2.length > 0) {
          this.listaPecasProcessuaisObrigatoria.push(data2);
        }

        if (this.origemFilter != null) {
          let testFilter = this.listaPecasProcessuaisObrigatoria.filter((tipo) => tipo.nmTipoDocumento == this.origemFilter)[0];

          if (testFilter != undefined) {
            this.tipoDocumento = testFilter;
          }
        }

        if (this.isJurisdicionado && !this.isCGE) {
          if ((<HTMLInputElement>document.getElementById("file"))) {
            if (this.tipoAnalise == '0' || this.tipoDocumento != null || this.tipoDocumento != undefined || this.tipoDocumento != '') {
              if (this.tipoDocumento == 45 && this.isModuloPeca == true) {
                (<HTMLInputElement>document.getElementById("file")).disabled = true;
              } else {
                (<HTMLInputElement>document.getElementById("file")).disabled = false;
              }
            } else {
              if (this.tipoDocumento == 45 && this.isModuloPeca == true) {
                (<HTMLInputElement>document.getElementById("file")).disabled = true;
              } else {
                (<HTMLInputElement>document.getElementById("file")).disabled = false;
              }
            }
          }
        }
      }, error => console.log("erro: " + error));

    }, error => console.log("erro: " + error));
  }

  onTipoDocumentoChange(item) {
    this.tipoEntidadeExercicio = item.idTipoEntidadeExercicio;
    this.tipoDocumento = item.idTipoDocumento;

    if (this.isJurisdicionado && !this.isCGE) {
      this.disabled = false;
      (<HTMLInputElement>document.getElementById("file")).disabled = false;
    }
  }

  baixarArquivo(arquivo) {
    this.loading = true;
    this.fileService.baixarArquivo(arquivo);
    this.loading = false;
  }

  fileChange(event) {
    this.alertService.mostraModalConfirmacao("Salvar Peça", "Arquivo selecionado, confirma importação ?", callback => {
      if (callback) {

        let fileList: FileList = event.target.files;
        if (fileList.length > 0) {
          let file: File = fileList[0];

          // if (file.size <= 10485760 || this.tipoDocumento == 335) {
          // console.log(this.tipoDocumento);
          // console.log(JSON.stringify(this.tipoDocumento.idTipoDocumento));

          let idTipoDoc = null;


          if (this.tipoDocumento != undefined) {

            if (this.tipoDocumento.idTipoDocumento != undefined) {
              idTipoDoc = this.tipoDocumento.idTipoDocumento;

              /*if (this.tipoDocumento.idTipoDocumento == 335) {
                if (file.type != 'text/plain') {
                  this.alertService.mostraAlerta('', 'Somente arquivos TXT são aceitos na peça SPED');
                  return;
                }
              }*/

            } else {
              idTipoDoc = this.tipoDocumento;
              /*if (this.tipoDocumento == 335) {
                if (file.type != 'text/plain') {
                  this.alertService.mostraAlerta('', 'Somente arquivos TXT são aceitos na peça SPED');
                  return;
                }
              }*/
            }

          }

          this.fileService.salvarPeca(event, this.IdProcesso, this.idModuloPCA, this.tipoAnalise, this.tipoEntidadeExercicio, idTipoDoc, this.origemArquivo).subscribe(data => {
            this.alertService.mostraAlerta("", "Arquivo adicionado com sucesso!");
            this.carregarModal();

            if (this.tipoAnalise != 0 && !this.isCGE) {
              this.disabled = true;
              (<HTMLInputElement>document.getElementById("file")).disabled = true;
            }
          }, error => {
            this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar arquivo: " + error.mensagem);
          });
          // } else {
          //   this.alertService.mostraAlerta("", "Arquivo ultrapassou o limite de tamanho de 10Mb.");
          // }
        }
      }
    });
  }

  deletarArquivo(idArquivo, nomeArquivo) {
    this.alertService.mostraModalConfirmacao("Excluir Arquivo", "Você tem certeza que deseja excluir o arquivo " + nomeArquivo + "?",
      retornoModal => {
        if (retornoModal) {
          this.fileService.deletarArquivo(idArquivo).subscribe(data => {
            this.alertService.mostraAlerta("", "Arquivo excluído com sucesso.");
            this.carregarModal();
            //this.listarArquivosPCA();
          }, error => {
            this.alertService.mostraAlerta("", "Houve um erro ao excluir arquivo.");
          });
        }
      }
    );
  }

  assinarArquivos(arquivo) {

    // Assinar arquivo
    let assinar = this.AGORA.assinarArquivos(arquivo.idArquivoVinculado, this.PCAAtiva.id, this.usuarioLogado.dadosUsuario[0].cpf, this.usuarioService.obterDadosUsuario().perfil);
    assinar.subscribe(
      next => {
        console.log('Sucesso: %s', next);
        this.dismiss();
      },
      error => {
        console.log('Erro: %s', error);
        this.alertService.mostraAlerta("Erro encontrado", error);
      });

  }

  exibirAssinantes(myEvent, assinantes) {

    let options: PopoverOptions = {
      cssClass: "popover-assinantes",
      showBackdrop: false,
      enableBackdropDismiss: false
    };

    let popover = this.popoverCtrl.create(PopoverAssinantesPage, { assinantes: assinantes }, options);
    popover.present({
      ev: myEvent
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/modais/modal-arquivos-contratos/modal-arquivos-contratos.ts